module.exports = __webpack_public_path__ + "img/53.2030fd2e.jpg";